import React from 'react';
import { Button } from '@components';
import { InlineNotification, Modal, Typography } from 'gd-design-library';
import classnames from 'classnames/bind';
import styles from './CancelOrderModal.module.scss';

const cx = classnames.bind(styles);

const CN = 'cancel-order-modal';
const alertClassName = `${CN}__alert`;
const buttonsRowClassName = `${CN}__buttons-row`;
const cancelButtonClassName = `${buttonsRowClassName}__cancel-button`;

interface Props {
  onCancelOrder: (orderId: string) => Promise<unknown>;
  handleClose: () => void;
  open: boolean;
  isLoading: boolean;
  orderId: string;
  message?: string;
  status: 'pending' | 'confirmed' | 'denied';
}

export const CancelOrderModal: React.FC<Props> = ({
  onCancelOrder,
  handleClose,
  open,
  isLoading,
  orderId,
  status,
  message
}) => (
  <Modal
    isOpen={ open }
    onClose={ handleClose }
    title='Order Cancellation'
  >
    <Typography>
      {status === 'pending' ?
        'Do you want to cancel your order?' :
        (
          status === 'denied' ?
            'Cancellation Failed' :
            message
        )
      }
    </Typography>
    <InlineNotification
      className={ cx(alertClassName) }
      variant={ status !== 'denied' ? 'warning' : 'error' }
    >
      <Typography variant='h6'>
        {status !== 'denied' ? 'Refunds may take up to 5-7 business days to reflect on your account.' : message}
      </Typography>
    </InlineNotification>
    <div className={ cx(buttonsRowClassName) }>
      <Button variant='text' onClick={ handleClose }>
        {status === 'pending' ? 'Cancel' : 'Close'}
      </Button>
      {status === 'pending' ? <Button
        className={ cx(cancelButtonClassName) }
        loading={ isLoading }
        onClick={ (): void => { onCancelOrder(orderId); } }
      >
          Cancel Order
      </Button> : null}
    </div>
  </Modal>
);

